module.exports = __webpack_public_path__ + "static/media/icon_05.e7d9434d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_05.png
// module id = 1646
// module chunks = 1